import React from 'react';
import cx from 'classnames';
import { range } from 'lodash';
import { LinearProgress } from '@material-ui/core';

import { useStyles } from './useStyles';

const DEFAULT_LOADERS = 4;
const CUSTOM_MODEL_LOADERS = 5;
const ONLY_CUSTOM_MODEL_LOADERS = 2;

export const Loaders = ({
  className,
  avgCompletionPercent,
  isTrainingModel,
  onlyTrainingModel,
}) => {
  const loadersCount = onlyTrainingModel
    ? ONLY_CUSTOM_MODEL_LOADERS
    : isTrainingModel
    ? CUSTOM_MODEL_LOADERS
    : DEFAULT_LOADERS;

  const styles = useStyles({ loadersCount });

  return (
    <div className={cx(className, styles.root)}>
      {range(1, loadersCount + 1).map((num, index) => {
        const min = (100 / loadersCount) * (num - 1);
        const max = (100 / loadersCount) * num - 1;
        return (
          <LinearProgress
            key={`${num}-${index}`}
            className={styles.loader}
            variant={
              avgCompletionPercent < min || avgCompletionPercent > max
                ? 'determinate'
                : 'indeterminate'
            }
            value={avgCompletionPercent > max ? 100 : 0}
          />
        );
      })}
    </div>
  );
};
